module.exports = __webpack_public_path__ + "img/Group 465.70387639.png";